exports = module.exports = require("../../../../../landing-page/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".area-hint {\n  line-height: 1;\n  color: #606671;\n  background-color: rgba(255, 255, 255, 0.9);\n  border-radius: 18px;\n  padding: 2px 9px;\n  -webkit-box-shadow: 0 2px 3px rgba(96, 102, 113, 0.3);\n          box-shadow: 0 2px 3px rgba(96, 102, 113, 0.3);\n  text-align: center;\n  margin: 18px;\n  z-index: 2;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/alextaxiera/source/farmhand-server/client/landing-page/~/css-loader!/Users/alextaxiera/source/farmhand-server/client/landing-page/~/postcss-loader/lib?{"plugins":[null]}!/Users/alextaxiera/source/farmhand-server/client/dashboard/src/js/components/area-hint/index.css
// module id = ../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/lib/index.js?{"plugins":[null]}!../../../dashboard/src/js/components/area-hint/index.css
// module chunks = 0